<template>
  <div class="col-6">
    <slot />
  </div>
</template>
